import { Link } from 'react-router';

export function NotFound() {
  return (
    <div className="flex items-center justify-center min-h-[60vh]">
      <div className="text-center">
        <h1 className="text-6xl font-display font-bold text-brand mb-4">404</h1>
        <p className="text-slate-400 text-lg mb-6">Page not found</p>
        <Link
          to="/"
          className="inline-block px-6 py-3 bg-brand hover:bg-brand-dark text-white font-semibold rounded-lg transition-colors"
        >
          Back to Dashboard
        </Link>
      </div>
    </div>
  );
}
